import {
  ActivatedRouteSnapshot,
  RedirectCommand,
  Resolve,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { Quote } from "../quote.type";
import { QuoteRepository } from "../quote.repository";
import { Observable, of } from "rxjs";
import { Injectable, inject } from "@angular/core";
import { catchError } from "rxjs/operators";
import { UserService } from "app/user/user.service";
import { QuoteHandoverService } from "./quote-handover.service";
import { notFoundOr } from "app/ui/not-found/not-found-redirect";

@Injectable()
export class QuoteResolver implements Resolve<Quote> {
  private quoteRepository = inject(QuoteRepository);
  private router = inject(Router);
  private userService = inject(UserService);
  private quoteHandover = inject(QuoteHandoverService);

  resolve(
    route: ActivatedRouteSnapshot,
    rstate: RouterStateSnapshot,
  ): Observable<Quote | RedirectCommand> {
    // The form swaps `quote/0` for the real url once the quote exists and hands the quote over -
    // refetching it here would be pointless, and recreating it would leave an orphan behind.
    const handedOverQuote = this.quoteHandover.take(route.params.id);
    if (handedOverQuote) {
      return of(handedOverQuote);
    }

    let payload = null;
    const navigationState = this.router.getCurrentNavigation().extras.state;
    const clientIds: number[] = navigationState
      ? navigationState.clientIds
      : null;
    if (Array.isArray(clientIds) && clientIds.length) {
      payload = { clients: clientIds };
    }

    if (route.params.id === "0") {
      return new Observable<Quote>((observer) => {
        this.userService.getUser().then((user) => {
          this.quoteRepository
            .createQuote(payload, user.getLastQuoteType())
            .pipe(catchError((e) => of(null)))
            .subscribe((quote) => {
              observer.next(quote);
              observer.complete();
            });
        });
      });
    }

    return this.quoteRepository
      .getQuote(route.params.id)
      .pipe(notFoundOr("Quote", this.router, rstate));
  }
}
